<template>
  <v-container>
    <v-row class="align-center justify-center">
      <v-col cols="12" md="12" align-self="center" style="overflow-x: auto">
        <div id="container-chart" style="min-width: 450px; min-height: 350px"></div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import moment from "moment";
import Highcharts from "highcharts";
import Accessibility from "highcharts/modules/accessibility";
import Exporting from "highcharts/modules/export-data";
Accessibility(Highcharts);
Exporting(Highcharts);
export default {
  name: "RainFlowChart",
  props: [
    "location",
    "minDaysForecast",
    "maxDaysForecast",
    "forecasts",
    "flowForecasts",
    "siprecDailyEstimated",
    "prevHidroDaily",
  ],
  data: () => ({
    chartRendered: undefined,
  }),
  methods: {
    chartPreprocessing() {
      const elementId = "container-chart";
      let chart = document.getElementById(elementId);
      let series = [];
      series = [
        this.createDataSerie(
          this.formatNewChartValues(this.siprecDailyEstimated.slice(90)),
          "Chuva estimada",
          "column",
          "mm",
          0,
          1
        ),
        this.createDataSerie(
          this.formatChartValues(this.forecasts, 22, "precIntensity"),
          "Chuva prevista",
          "column",
          "mm",
          0,
          1
        ),
        this.createDataSerie(
          this.formatNewChartPreviousFlowForecastsValues(this.prevHidroDaily),
          "Vazão estimada",
          "line",
          "m³/s",
          1,
          3
        ),
        this.createDataSerie(
          this.formatChartFlowForecastsValues(this.flowForecasts, 2, "flow"),
          "Vazão prevista",
          "line",
          "m³/s",
          1,
          3
        ),
      ];
      if (series) {
        this.charts(elementId, series);
        this.loading = false;
        chart.style.visibility = "visible";
        chart.style.display = "block";
      } else {
        chart.style.visibility = "hidden";
        chart.style.display = "none";
      }

      this.$emit("chartRenderComplete", this.chartRendered);
    },
    async charts(elementId, series) {
      Highcharts.setOptions({
        lang: {
          months: [
            "Janeiro",
            "Fevereiro",
            "Março",
            "Abril",
            "Maio",
            "Junho",
            "Julho",
            "Agosto",
            "Setembro",
            "Outubro",
            "Novembro",
            "Dezembro",
          ],
          shortMonths: [
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez",
          ],
          weekdays: [
            "Domingo",
            "Segunda",
            "Terça",
            "Quarta",
            "Quinta",
            "Sexta",
            "Sábado",
          ],
        },
      });
      this.chartRendered = Highcharts.chart(elementId, {
        colors: [
          this.$vuetify.theme.themes.dark.secondary.base,
          this.$vuetify.theme.themes.dark.primary.base,
        ],
        colorAxis: {
          gridLineColor: this.$vuetify.theme.themes.dark.primary.darken1,
        },
        chart: {
          //type: type,
          backgroundColor: this.$vuetify.theme.themes.dark.primary.darken1,
          height: 600,
          //height: (9 / 16 * 100) + '%' // 16:9 ratio
        },
        plotOptions: {
          column: {
            borderWidth: 0,
          },
        },
        exporting: {
          enabled: false,
          filename: `Chuva e vazão - ${this.location ? this.location.text : ""}`,
          sourceWidth: 1000,

          chartOptions: {
            title: {
              text: `Chuva e vazão - ${this.location ? this.location.text : ""}`,
              style: {
                color: "#FFFFFF",
              },
            },
            subtitle: {
              text: `${moment(this.prevHidroDaily[0].date).format("DD/MM/YYYY")}  até ${moment(this.prevHidroDaily[this.prevHidroDaily.length-1].date).add(this.maxDaysForecast, "days").format("DD/MM/YYYY")}`,
              style: {
                color: "#FFFFFF",
              },
            },

            xAxis: {
              tickInterval: 24 * 3600 * 1000,
            },
          },
        },
        title: {
          text: "",
        },
        credits: {
          enabled: true,
          href: "http://www.simepar.br/",
          text: "by: SIMEPAR",
          style: {
            color: "#FFFFFF",
          },
        },
        legend: {
          enabled: true,
          itemStyle: {
            color: "#FFFFFF",
          },
          itemHoverStyle: {
            color: "#979797",
          },
        },
        xAxis: {
          accessibility: {
            description: `Do dia ${moment(this.prevHidroDaily[0].date).format("DD/MM/YYYY")}  até ${moment(this.prevHidroDaily[this.prevHidroDaily.length-1].date).add(this.maxDaysForecast, "days").format("DD/MM/YYYY")}`,
          },
          tickColor: "#2D324F",
          tickWidth: 2,
          lineWidth: 2,
          lineColor: "#2D324F",
          type: "datetime",
          ordinal: false,
          crosshair: {
            enabled: true,
          },
          //tickInterval: 12* 3600*1000,
          labels: {
            format: "{value:%d/%m/%Y}",
            style: {
              color: "#FFFFFF",
            },
          },
          plotLines: [
            {
              value: this.dateToUTC(moment().format("YYYY-MM-DD")),
              //dashStyle: 'dash',
              width: 2,
              color: "white",
              label: {
                text: "Previsão para 7 dias",
                rotation: 0,

                style: {
                  color: "#FFFFFF",
                  fontSize: "12",
                },
              },
              zIndex: 8,
            },
          ],
        },
        yAxis: [
          {
            //tickInterval: 0.5,
            type: "numeric",
            min: 0,
            title: {
              text: "Chuva (mm)",
              style: {
                color: "#FFFFFF",
              },
            },
            accessibility: {
              description: "Chuva (mm)",
            },
            labels: {
              format: "{value}",
              style: {
                color: "#FFFFFF",
              },
            },
            height: "45%",
            lineWidth: 2,
            lineColor: "#2D324F",
            gridLineWidth: 1,
            gridLineColor: "#2D324F",
            resize: {
              enabled: true,
            },
            reversed: true,
            opposite: false,
          },
          {
            lineWidth: 2,
            lineColor: "#2D324F",
            gridLineWidth: 1,
            gridLineColor: "#2D324F",
            min: 0, //Math.min(... series[3].data.map(value => value[1])),
            title: {
              text: "Vazão (m³/s)",
              style: {
                color: "#FFFFFF",
              },
            },
            accessibility: {
              description: "Vazão (m³/s)",
            },
            labels: {
              format: "{value}",
              style: {
                color: "#FFFFFF",
              },
            },
            top: "55%",
            height: "45%",
            offset: 0,
            reversed: false,
            opposite: false,
          },
        ],
        tooltip: {
          //enabled: true,
          shared: true,
          split: true,
          //crosshairs: true,
          useHTML: true,
          xDateFormat: '%d/%m/%Y',
          // xDateFormat: "%A, %b %d",
          pointFormatter: function () {
            const value = this.series.userOptions.valueDecimals
              ? Number(this.y).toFixed(this.series.userOptions.valueDecimals)
              : this.y;
            return (
              '<strong style="color:' +
              this.series.color +
              '">' +
              this.series.name +
              "</strong>: <strong>" +
              value +
              " " +
              this.series.userOptions.valueSuffix +
              "<strong/>"
            );
          },
        },
        series: [
          ...series,
        ],
        caption: {
          text: `Gráfico de chuva e vazão com dados de ${moment(this.prevHidroDaily[0].date).format("DD/MM/YYYY")}  até ${moment(this.prevHidroDaily[this.prevHidroDaily.length-1].date).add(this.maxDaysForecast, "days").format("DD/MM/YYYY")}`,
          style: { color: "#FFFFFF" },
        },
        responsive: {
          rules: [
            {
              condition: {
                maxWidth: 500,
              },
              chartOptions: {
                legend: {
                  layout: "horizontal",
                  align: "center",
                  verticalAlign: "bottom",
                },
              },
            },
          ],
        },
      });
    },
    createDataSerie(data, name, type, valueSuffix, yAxis, valueDecimals) {
      let serie = { type, name, valueSuffix, yAxis, valueDecimals };
      serie.data = [];
      for (let i in data) {
        let arrayItem = [];
        let x = this.dateToUTC(data[i].date);
        let y = data[i].value;
        arrayItem.push(x);
        arrayItem.push(y);
        serie.data.push(arrayItem);
      }

      return serie;
    },
    formatNewChartValues(forecast) {
      let data = [];
      if (forecast) {
        for (const key in forecast) {
          data.push({ value: forecast[key].value.precIntensity, date: forecast[key].date });
        }
      }
      return data;
    },
    formatChartValues(forecasts, sourceid, property) {
      let data = [];
      const forecast = forecasts.find((element) => element.sourceid === sourceid);
      if (forecast) {
        for (const key in forecast.value) {
          const { date } = forecast.value[key];
          data.push({ value: Number(forecast.value[key][property]), date });
        }
      }
      return data;
    },
    formatNewChartPreviousFlowForecastsValues(forecasts) {
      let data = [];
      if (forecasts) {
        for (const key in forecasts) {
          const forecast = forecasts[key];
          const { date } = forecast;
          if (moment(date).isSameOrBefore(moment(), "day")) {
            const value =
              forecast.value
                ? forecast.value.flow
                : undefined;
            data.push({ value, date });
          }
        }
      }
      return data;
    },
    formatChartPreviousFlowForecastsValues(forecasts, sourceid, property) {
      let data = [];
      if (forecasts) {
        for (const key in forecasts) {
          const forecast = forecasts[key];
          const { date } = forecast;
          if (moment(date).isSameOrBefore(moment(), "day")) {
            const value =
              forecast.value && forecast.value[0]
                ? forecast.value[0][property]
                : undefined;
            data.push({ value, date });
          }
        }
      }
      return data;
    },
    formatChartFlowForecastsValues(forecasts, sourceid, property) {
      let data = [];
      if (forecasts) {
        for (const key in forecasts) {
          const forecast = forecasts[key];
          const { date } = forecast;
          if (moment(date).isSameOrAfter(moment(), "day")) {
            const value =
              forecast.value && forecast.value[0]
                ? forecast.value[0][property]
                : undefined;
            data.push({ value, date });
          }
        }
      }

      return data;
    },
    dateToUTC(date) {
      const utc = moment(date, "YYYY-MM-DD");
      return utc.valueOf();
    },
    avarage(array) {
      if (array.length) {
        return array.reduce((a, b) => a + b) / array.length;
      }
      return 0;
    },
  },
};
</script>

<style></style>
